module.exports = __webpack_public_path__ + "img/cosco.c1eedccf.jpeg";